import { RightOutlined } from "@ant-design/icons"
import { Flex, Typography } from "antd"
import React, { type ReactNode } from "react"

import {
  type OverviewAccent,
  OverviewCardIcon
} from "../overview/OverviewCardIcon.tsx"

const { Text } = Typography

interface DocumentCreateMenuOptionProps {
  icon: ReactNode
  accent: OverviewAccent
  title: string
  description: string
  onClick?: () => void
}

/**
 * One row inside a "Create" dropdown — purely presentational. When used as
 * the label of an antd `Dropdown` menu item its own `onClick` fires; when
 * embedded as the child of an `Upload` (see `LeadViewDocumentUpload`'s
 * `render` prop), the click is intercepted by `Upload` itself to open the
 * file picker and `onClick` is omitted.
 */
function DocumentCreateMenuOption({
  icon,
  accent,
  title,
  description,
  onClick
}: DocumentCreateMenuOptionProps) {
  return (
    <Flex
      align={"center"}
      gap={"middle"}
      onClick={onClick}
      className={"w-full py-1 cursor-pointer"}
    >
      <OverviewCardIcon icon={icon} accent={accent} size={32} />
      <Flex vertical gap={0} className={"flex-1 min-w-0"}>
        <Text strong>{title}</Text>
        <Text type={"secondary"} className={"text-xs"}>
          {description}
        </Text>
      </Flex>
      <RightOutlined className={"text-xs text-gray-400"} />
    </Flex>
  )
}

export { DocumentCreateMenuOption }
